import Normolizer from './normalizers';

const phoneMustBeTenDigits = phone => {
  const phonePattern = /^\d{10}$/;
  return phonePattern.test(Normolizer.normalizePhoneOrFax(phone));
};

const zipCodeMustBeFiveDigits = zip => {
  const zipPattern = /^\d{5}$/;
  return zipPattern.test(zip);
};

export { phoneMustBeTenDigits, zipCodeMustBeFiveDigits };
